<template>
  <v-card color="grey lighten-4" outlined light>
    <v-toolbar flat dense class="grey lighten-3 pa-0" style="width: 100%; max-width: 1200px;">
      <v-row no-gutters align="center" class="flex-nowrap">
        <!-- Título "Relatório" -->
        <v-col cols="auto" class="mr-2">
          <v-toolbar-title class="text-subtitle-1 font-weight-bold">Relatório</v-toolbar-title>
        </v-col>
        <v-spacer />
        <v-col cols="5" sm="4" md="4" lg="4" class="pr-2">
          <v-autocomplete v-model="modelo" :items="modeloRelatorio.modelos"
            :loading="isLoading" dense outlined hide-no-data hide-selected item-text="nome" item-value="_id"
            label="Buscar Modelos" placeholder="Digite para buscar" prepend-icon="mdi-database-search" return-object
            hide-details></v-autocomplete>
        </v-col>

        <!-- Botões de ação -->
        <v-col cols="auto" class="d-flex">
          <v-btn color="red accent-1" icon small @click="clear">
            <v-icon>mdi-broom</v-icon>
          </v-btn>

          <v-btn :disabled="manualName.length < 8" v-if="!idMedelo" icon small
            color="blue darken-1" @click="dialogNovoModelo = true">
            <v-icon>mdi-note-plus</v-icon>
          </v-btn>
          <v-btn v-else icon small :disabled="manualName.length < 8" color="teal darken-2"
            @click="dialogEditarModelo = true">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-toolbar>

    <v-card flat height="610px" class="overflow-auto">
      <tiptap-vuetify v-model="manualName" :card-props="{ flat: true }" :extensions="extensions"
        placeholder="Descreva o relatório médico..." />
    </v-card>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text dark color="orange accent-2" @click="$emit('voltar')">
        <v-icon right>undo</v-icon>
        voltar
      </v-btn>
      <v-btn :loading="loadSalvar" text dark color="blue accent-2" @click="salvar">
        <v-icon right>save</v-icon>
        Salvar
      </v-btn>
    </v-card-actions>

    <!-- Diálogo para novo modelo -->
    <v-dialog v-model="dialogNovoModelo" width="900">
      <v-card class="rounded-lg">
        <v-card-title class="text-h5 white--text primary py-4">
          <v-icon left color="white">mdi-plus-circle</v-icon>
          Cadastrar novo modelo
        </v-card-title>

        <v-card-text class="pa-6">
          <v-text-field label="Título" outlined v-model="tituloModelo"></v-text-field>
          <v-card outlined>
            <tiptap-vuetify v-model="manualName" :card-props="{ flat: true }" :extensions="extensions"
              placeholder="Descrição do modelo..." />
          </v-card>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="red lighten-1" text @click="dialogNovoModelo = false" class="px-4">
            <v-icon left>mdi-close-circle</v-icon>
            Cancelar
          </v-btn>
          <v-btn color="green darken-1" dark :loading="loadReceita" @click="cadastrarModeloRelatorio" class="px-4"
            depressed>
            <v-icon left>mdi-content-save</v-icon>
            Cadastrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo para editar modelo -->
    <v-dialog v-model="dialogEditarModelo" width="800">
      <v-card class="rounded-lg">
        <v-card-title class="text-h5 white--text teal darken-2 py-4">
          <v-icon left color="white">mdi-pencil-circle</v-icon>
          Editar modelo
        </v-card-title>

        <v-card-text class="pa-6">
          <v-text-field label="Título" outlined v-model="tituloModelo"></v-text-field>
          <v-card outlined>
            <tiptap-vuetify v-model="manualName" :card-props="{ flat: true }" :extensions="extensions"
              placeholder="Descrição do modelo..." />
          </v-card>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="red lighten-1" text @click="dialogEditarModelo = false" class="px-4">
            <v-icon left>mdi-close-circle</v-icon>
            Cancelar
          </v-btn>
          <v-btn color="blue darken-1" dark @click="cadastrarModeloRelatorio" class="px-4" depressed>
            <v-icon left>mdi-content-save-edit</v-icon>
            Salvar alterações
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import medicoService from '../../services/medico.service'
import {
  TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, Paragraph,
  BulletList, OrderedList, ListItem, Link, Blockquote, HardBreak, HorizontalRule, History
} from 'tiptap-vuetify'

export default {
  name: 'EditorRelatorioAtendimento',
  components: { TiptapVuetify },
  props: {
    paciente: {
      type: Object
    },
    relatorio: Object
  },
  data () {
    return {
      inputMode: 'manual',
      manualName: '',
      tituloModelo: '',
      dialogNovoModelo: false,
      dialogEditarModelo: false,
      loadRelatorio: false,
      idMedelo: null,
      isLoading: false,
      menu2: false,
      date: new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      model: { nome: '' },
      modeloRelatorio: {},
      modelo: null,
      search: null,
      loadReceita: false,
      loadSalvar: false,
      relatorioExistente: null,
      user: null,
      extensions: [
        History, Blockquote, Link, Underline, Strike, Italic, ListItem, BulletList, OrderedList,
        [Heading, { options: { levels: [1, 2, 3] } }], Bold, Code, HorizontalRule, Paragraph, HardBreak
      ]
    }
  },

  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    }
  },
  methods: {
    clear () {
      this.manualName = ''
      this.modelo = null
      this.tituloModelo = ''
      this.idMedelo = null
    },

    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    cadastrarModeloRelatorio () {
      this.loadReceita = true
      const modeloRelatorio = {
        idUsuario: this.user.id,
        nome: this.tituloModelo,
        descricao: this.manualName,
        _id: this.idMedelo
      }

      medicoService.medico.cadastrarModeloRelatorio(modeloRelatorio)
        .finally(() => {
          this.loadReceita = false
          this.dialogNovoModelo = false
          this.dialogEditarModelo = false
          this.idMedelo = null
          this.buscarModeloRelatorio()
        })
    },

    buscarModeloRelatorio () {
      medicoService.medico.buscarModeloRelatorio(this.user.id)
        .then((r) => {
          if (r.status === 200) {
            this.modeloRelatorio = r.data
          }
        })
    },

    buscarRelatorioExistente () {
      if (this.idRelaorio != null) {
        this.loadRelatorio = true
        medicoService.medico.buscarRelatorioPorId(this.idRelaorio)
          .then((r) => {
            if (r.status === 200 && r.data && r.data.length > 0) {
              this.relatorioExistente = r.data[0]
              this.manualName = this.relatorioExistente.descricao || ''
            }
          })
          .finally(() => {
            this.loadRelatorio = false
          })
      }
    },

    salvar () {
      this.loadSalvar = true

      const dadosRelatorio = {
        idAtendimento: this.paciente.idAtendimento,
        descricao: this.manualName,
        idRelatorio: this.relatorio && this.relatorio.id
      }

      const operacao = (this.relatorio && this.relatorio.id)
        ? medicoService.medico.atualizarRelatorio(dadosRelatorio)
        : medicoService.medico.cadastrarRelatorio(dadosRelatorio)

      operacao
        .then(() => this.$emit('voltar'))
        .catch(error => console.error('Erro ao salvar:', error))
        .finally(() => { this.loadSalvar = false })
    }
  },
  mounted () {
    this.user = this.$store.getters.usuario
    this.buscarModeloRelatorio()
    // this.buscarRelatorioExistente()
  },
  watch: {
    modelo (val) {
      if (val) {
        this.tituloModelo = val.nome
        this.idMedelo = val._id
        this.manualName = val.descricao
      }
    },
    manualName (val) {
      this.$emit('relatorioAtendimento', val)
    },
    relatorio (val) {
      if (val != null) {
        this.manualName = val.descricao
      } else {
        this.manualName = ''
      }
    }
  }
}
</script>

<style scoped>
/* Estilos personalizados podem ser adicionados aqui */
</style>
